<template>
  <div class="multiple-language-wrapper">
    <aha-dropdown-v2>
      <aha-dropdown-trigger-v2 class="--select-multiple-language">
        <aha-antd-button variant="tertiary" icon-name="globe" icon-view-box="0 0 16 16">
          <span class="--selected-language">
            {{ presenterLocale }}
          </span>
        </aha-antd-button>
      </aha-dropdown-trigger-v2>
      <aha-dropdown-menu>
        <aha-dropdown-item
          v-for="(option, optionIndex) in languageOptions"
          :key="optionIndex"
          class="content-center"
          @click="selectLanguage(option)"
        >
          {{ option.name }}
        </aha-dropdown-item>
      </aha-dropdown-menu>
    </aha-dropdown-v2>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import constants from '@/constant'
import util from '@/util'

export default {
  data() {
    return {
      languageOptions: constants.languageOptions,
      languageSelected: {},
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presenterLocale: (state) => state.presenterLocale,
    }),
  },
  mounted() {
    this.initLanguage()
  },
  methods: {
    ...mapActions(['setSelectedSortCriteriaAction', 'patchCurrentUserAction']),
    initLanguage() {
      try {
        const languageCode = window.localStorage.getItem('ahaslides-presenter-language')
        if (languageCode) {
          const index = this.languageOptions.findIndex((item) => item.language === languageCode)
          if (index !== -1) {
            this.languageSelected = constants.languageOptions[index]
          }
        }
      } catch (error) {
        Sentry.captureException(error)
      }

      if (!this.languageSelected.language) {
        // eslint-disable-next-line prefer-destructuring
        this.languageSelected = this.languageOptions[0]
      }
    },
    async selectLanguage(item) {
      const oldLang = this.presenterLocale
      this.languageSelected = item
      this.$store.dispatch('setPresenterLang', item.language)
      if (this.currentUser.id) {
        this.currentUser.personalInformation = this.currentUser.personalInformation || {}
        const payload = {
          personalInformation: this.currentUser.personalInformation,
        }
        payload.personalInformation.presenterLanguage = item.language
        await this.patchCurrentUserAction({
          userId: this.currentUser.id,
          ...payload,
        })
      }
      window.localStorage.setItem('ahaslides-presenter-language', item.language)
      this.$store.state.presenterLanguageSelected = item.language

      let category = constants.eventCategories.PRESENTATION_LIST
      if (this.$route.name === 'Login') {
        category = constants.eventCategories.PRESENTER_LOGIN
      } else if (this.$route.name === 'Register') {
        category = constants.eventCategories.PRESENTER_REGISTER
      }
      const eventAction = 'Header > language > Select language'
      const trackData = {
        eventAction,
        eventCategory: category,
        eventLabel: item.language,
        currentLanguage: oldLang,
        userId: this.currentUser.id,
      }
      util.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>

.multiple-language-wrapper {
  position: absolute;
  top: 33px;
  right: 0;

  .--selected-language {
    font-weight: 600;
    text-transform: uppercase;
  }

  ::v-deep .aha-dropdown-menu-ai {
    width: auto !important;
    left: auto;
    right: 0;
  }
}
</style>
